import { VFC } from "react";
import ReactModal from "react-modal";
import { Icon } from "capitalrx-components-2.0";
import Styles from "./Modal.module.scss";
import classNames from "classnames";
import { ModalBody } from "./ModalBody";

import { ModalProps, ModalSubComponents } from "./Modal.props";

const rootElement = document ? document.getElementById("root") : null;
if (rootElement) ReactModal.setAppElement(rootElement);

/**
 * @deprecated
 * A component that displays a modal on the screen.
 */
export const Modal: VFC<ModalProps> & ModalSubComponents = (props: ModalProps): JSX.Element | null => {
  const { className, visible = false, scrollable = true, onClose, children, title, id, testId } = props;

  return (
    <ReactModal
      isOpen={visible}
      overlayClassName={Styles.modalOverlay}
      className={classNames(Styles.modal, className)}
      shouldCloseOnOverlayClick
      onRequestClose={onClose}
      id={id}
      testId={testId}
    >
      <div className={`header ${title ? "hasTitle" : null}`}>
        <div className="title">{title}</div>
        <button className="closeButton" onClick={onClose}>
          <Icon name="x" color="black" size="small" />
        </button>
      </div>
      <div className={classNames("modalBodyContainer", { scrollable: scrollable })}>{children}</div>
    </ReactModal>
  );
};

Modal.Body = ModalBody;
